import {
  BlockControls,
  MediaPlaceholder,
  MediaUpload
} from '@wordpress/block-editor'
import { Button, IconButton, Placeholder, Toolbar } from '@wordpress/components'
import { useEntityProp, useEntityRecord } from '@wordpress/core-data'
import React from 'react'
import useIsSelected from '../hooks/useIsSelected'
import './PostThumbnailEditor.css'

export type PostThumbnailEditorProps = {
  postType: string
  postId: number
  className?: string
  wrapClassName?: string
  placeholderClassName?: string
}

export default function PostThumbnailEditor({
  postId,
  postType,
  className,
  wrapClassName,
  placeholderClassName
}: PostThumbnailEditorProps): JSX.Element {
  const isSelected = useIsSelected()
  const [thumbnailId, setThumbnailId] = useEntityProp(
    'postType',
    postType,
    'featured_media',
    String(postId)
  )
  const thumbnail = useEntityRecord<any>('postType', 'attachment', thumbnailId)
    ?.record

  return (
    <MediaPlaceholder
      onSelect={(el) => {
        setThumbnailId(el.id)
      }}
      // @ts-ignore
      placeholder={(content) =>
        thumbnailId ? (
          <div className={`yt-image-editor-placeholder ${wrapClassName}`}>
            <img
              src={thumbnail?.source_url}
              alt={thumbnail?.title.rendered}
              className={className}
            />
            <MediaUpload
              onSelect={(el) => setThumbnailId(el.id)}
              allowedTypes={['image']}
              value={thumbnail?.source_url}
              render={({ open }) => (
                <div className="yt-image-editor-toolbar">
                  <button
                    className="components-button editor-post-featured-image__action"
                    onClick={open}
                  >
                    Ersetzen
                  </button>
                  <button
                    className="components-button editor-post-featured-image__action"
                    onClick={() => setThumbnailId(null)}
                  >
                    Entfernen
                  </button>
                </div>
              )}
            />
          </div>
        ) : (
          <div className={wrapClassName}>
            <Placeholder
              withIllustration={!isSelected}
              label="Bild auswählen"
              className={placeholderClassName}
            >
              {content}
            </Placeholder>
          </div>
        )
      }
      accept="image/*"
    />
  )
}
